import { fetchWithAuth } from '../helpers';

const getAll = async () => {
  const response = await fetchWithAuth(`${process.env.REACT_APP_API_URL}/api/questions/`, {
    method: 'GET',
    headers: { "ngrok-skip-browser-warning": "69420" },
  });
  return handleResponse(response);
};

const getAllPaginated = async (params: { page: number; limit: number; search?: string; question_type_id?: string; question_topic_id?: string; difficulty?: string; grade_ids?: string }) => {
  const queryParams = new URLSearchParams({
    page: params.page.toString(),
    limit: params.limit.toString(),
  });

  if (params.search) queryParams.append('search', params.search);
  if (params.question_type_id) queryParams.append('question_type_id', params.question_type_id);
  if (params.question_topic_id) queryParams.append('question_topic_id', params.question_topic_id);
  if (params.difficulty) queryParams.append('difficulty', params.difficulty);
  if (params.grade_ids) queryParams.append('grade_ids', params.grade_ids);

  const response = await fetchWithAuth(`${process.env.REACT_APP_API_URL}/api/questions?${queryParams.toString()}`, {
    method: 'GET',
    headers: { "ngrok-skip-browser-warning": "69420" },
  });
  return handleResponse(response);
};

const create = (question: any) => {
  return fetchWithAuth(`${process.env.REACT_APP_API_URL}/api/questions/`, {
    method: 'POST',
    headers: { 
      'Content-Type': 'application/json',
      "ngrok-skip-browser-warning": "69420" 
    },
    body: JSON.stringify(question)
  })
    .then(handleResponse);
};

const update = (question: any) => {
  return fetchWithAuth(`${process.env.REACT_APP_API_URL}/api/questions/${question.id}`, {
    method: 'PUT',
    headers: { 
      'Content-Type': 'application/json',
      "ngrok-skip-browser-warning": "69420" 
    },
    body: JSON.stringify(question)
  })
    .then(handleResponse);
};

const remove = (id: number) => {
  return fetchWithAuth(`${process.env.REACT_APP_API_URL}/api/questions/${id}`, {
    method: 'DELETE',
    headers: { "ngrok-skip-browser-warning": "69420" }
  })
    .then(handleResponse);
};

const removeMultiple = (ids: number[]) => {
  return fetchWithAuth(`${process.env.REACT_APP_API_URL}/api/questions/bulk-delete`, {
    method: 'POST',
    headers: { 
      'Content-Type': 'application/json',
      "ngrok-skip-browser-warning": "69420" 
    },
    body: JSON.stringify({ ids })
  })
    .then(handleResponse);
};

const recreateMultiple = (payloads: any[]) => {
  return fetchWithAuth(`${process.env.REACT_APP_API_URL}/api/questions/bulk-recreate`, {
    method: 'POST',
    headers: { 
      'Content-Type': 'application/json',
      "ngrok-skip-browser-warning": "69420" 
    },
    body: JSON.stringify({ questions: payloads })
  })
    .then(handleResponse);
};

function handleResponse(response: any) {
  return response.text().then((text: string) => {
    let data;
    try {
      data = text && JSON.parse(text);
    } catch (error) {
      data = text;
    }

    if (!response.ok) {
      const error = (data && data.message) || response.statusText;
      return Promise.reject(error);
    }

    return data;
  });
}

export const questionService = {
  getAll,
  getAllPaginated,
  create,
  update,
  remove,
  removeMultiple,
  recreateMultiple
};
